import { z } from 'zod/v4'
import { baseEntitySchema } from '../../core/entity.js'

/** Details are specified in the plugin(s) */
export const gearSchema = baseEntitySchema.extend({
  type: z.literal('gear'),
})

export type BaseGear = z.infer<typeof gearSchema>
